<template>
  <v-card elevation="2">
    <v-card-title>{{ reporte.titulo }}</v-card-title>
    <v-card-text v-if="reporte.layout">
      <GenerarComponentes :layout="reporte.layout" />
    </v-card-text>
  </v-card>
</template>

<script>
import GenerarComponentes from "./GenerarComponentes";
export default {
  name: "Cuerpo",
  components: {
    GenerarComponentes,
  },
  props: {
    reporte: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    tab: 0,
  }),
  mounted() {
    console.log(this.reporte.layout)
  }
};
</script>
